import Vue from 'vue';
import Component from 'vue-class-component';

import getParticipantsIcon from 'common/services/utils/getParticipantsIcon';

@Component({
  props: {
    activity: {
      type: Object,
      requried: true,
    },
  },
})
export default class CatalogReservationConfigHeaderComponent extends Vue {
  get participantsIcon() {
    return getParticipantsIcon(this.activity.participants);
  }
}
